<template>
  <div class="app-wrapper">
    <div id="app"
      :class="`${$route.name.split('-')[0]} ${osClass} scale-down-${scaleDown}`"
      :style="{backgroundImage: `url(${bgImage})`, backgroundColor: `#FCFCEF`}"
    >
      <fullscreen
        ref="fullscreen"
        background="#f9f9f9"
        :wrap="false"
        class="desktop-wrapperx"
        :class="{
          'scrollable': question.fields && question.fields.isScrollable,
          'full-area unselectable': $route.name === 'survey' || $route.name === 'survey-g',
          'full-area full-area-preview': $route.name === 'preview',
          'profile-page': $route.name === 'profile',
          'not-found': $route.name === 'not-found'
        }"
      >
        <transition name="page">
          <router-view
            v-on:fullscreen="goFullScreen()"
            v-on:fullscreen:off="turnOffFullScreen()"
            :bg-image="bgImage"
            :show-local-header="false"
          />
        </transition>
      </fullscreen>
    </div>
    <div class="shrug">
      <span class="super-big">¯\_(ツ)_/¯</span>
      Por favor gira el dispositivo<br>
      Turn your device portrait
    </div>
  </div>
</template>

<script>
import 'browser-report'
import Vue from 'vue'
import AuthService from 'Core/src/auth/authService'

Vue.use(AuthService)
Vue.prototype.$eventHub = new Vue()

export default {
  name: 'app',

  data () {
    return {
      fullscreen: false,
      usePortrait: false,
      publicPath: process.env.VUE_APP_BASE_URL,
      osClass: ''
    }
  },

  computed: {
    question () {
      if (this.$store.state.dataSet && this.$store.state.dataSet[parseInt(this.$route.params.qid, 10)]) {
        return this.$store.state.dataSet[parseInt(this.$route.params.qid, 10)]
      }
      return {}
    },
    surveyId () {
      return process.env.VUE_APP_DEFAULT_SID || this.$route.params.sid
    },
    routeName () {
      return this.$route.name
    },
    qid () {
      return this.$route.params.qid
    },
    bgImage () {
      if (this.$store.state.survey.backgroundImage && this.$store.state.survey.backgroundImage.fields) {
        return this.$store.state.survey.backgroundImage.fields.file.url
      }
      return ''
    },
    scaleDown () {
      const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
      const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
      if (vh < 700 && vw > 1200) {
        return true
      }
      return false
    }
  },

  components: {
    UsePortraitScreen: () => import('Components/base/UsePortraitScreen')
  },

  methods: {
    goFullScreen () {
      if (!this.fullscreen && this.$isMobile() && process.env.NODE_ENV !== 'development' && this.$route.name !== 'profile') {
        this.$refs.fullscreen.toggle()
        this.fullscreen = true
      }
    },
    turnOffFullScreen () {
      if (this.fullscreen) {
        this.$refs.fullscreen.toggle()
        this.fullscreen = false
      }
    },
    loadSite () {
      if (this.surveyId && !this.$store.state.survey.surveyId || this.surveyId && this.surveyId !== this.$store.state.survey.surveyId) {
        this.$store.dispatch('LOAD_NEW_SURVEY', { surveyId: this.surveyId })
      }
    },
    /*
     * Detect orientation and disable horizontal orientation for smartphones and small tablets
     */
    detectOrientation () {
      if (window.screen.height < window.screen.width && window.screen.height < 600 && !this.$route.name.includes('admin')) {
        this.usePortrait = true
      } else {
        this.usePortrait = false
      }
    }
  },

  mounted () {
    // We store the redirect_to_url var in localStorage
    var redirectTo = localStorage.getItem('redirect_to_url')
    if (redirectTo) { // ensure that no redirect happens if it's the same URL (home)
      localStorage.removeItem('redirect_to_url')
      setTimeout(() => {
        this.canRender = true
      }, 500)
      this.$router.push(redirectTo)
    } else {
      this.canRender = true
    }

    /*
     * Add a browser report. TODO: check if there's a better package that works with the Brave browser.
     */
    // eslint-disable-next-line
    browserReport((err, report) => {
      if (err) {
        throw err
      }
      this.$store.commit('BROWSER_REPORT', { report: report })
      if (report && report.os && report.os.name) {
        this.osClass = `class-${report.os.name}`
      }
    })

    /*
     * Add detectOrientation listener.
     */
    this.detectOrientation()
    window.addEventListener('resize', this.detectOrientation)

    /*
     * Load website on mounted.
     */
    this.loadSite()
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.detectOrientation)
  },
  watch: {
    'qid': function (newVal) {
      this.$store.commit('SET_ACTUAL_QID', { qid: parseInt(newVal, 10) })
      this.$store.commit('SET_CURRENT', { current: parseInt(newVal, 10) })
    }
  }
}
</script>

<style lang="scss">
.class-macOS {
  &.scale-down-true.survey,
  &.scale-down-true.survey-g {
    max-height: 120vh !important;
    height: 120vh !important;
    .desktop-wrapperx.full-area {
      transform: scale(0.85);      
      max-height: 120vh !important;
      height: 120vh !important;
    }
    .full-area,
    .question-wrapper.view {
      max-height: 117vh !important;
      height: 117vh !important;
    }
  }
}
.scale-down-true.survey,
.scale-down-true.survey-g,
.scale-down-true.preview {
  max-height: 120vh !important;
  height: 120vh !important;
  .desktop-wrapperx.full-area, {
    transform: scale(0.85);      
    max-height: 120vh !important;
    height: 120vh !important;
  }
  .full-area,
  .question-wrapper.view {
    max-height: 117vh !important;
    height: 117vh !important;
  }
}

body {
  margin: 0;
}

#app {
  font-family: 'Avenir', 'Nunito', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  max-width: 100vw;
  margin-left: auto;
  margin-right: auto;
  background-color: #fff;
  background-size: cover;
  background-position: center center;
  min-width: 100vw;
  height: auto;

  &.not-found {
    background-color: #F5F4F0;
    height: 100vh;
    display: flex;
  }

  &.home,
  &.shortcode {
    background: none !important;
  }

  .desktop-extended {
    overflow-y: scroll;
    @include breakpoint($desktop) {
      max-width: 600px;
    }
  }
}

.app-wrapper {
  min-height: 100vh;
  background: #FCFCEF;
}


.full-area {
  justify-content: center !important;
  &.not-found {
    background-color: #F5F4F0;
  }
}

.testeame-enter-active {
  animation: testeameKeyframe 0.2s;
}
.testeame-leave-active {
  animation: testeameKeyframe 0.2s reverse;
}
@keyframes testeameKeyframe {
  0% {
    opacity: 0.0001;
  }
  100% {
    opacity: 1;
  }
}
.shrug {
  z-index: -10000;
  opacity: 0.0001;
  transition: all 0.2s ease-in-out;
  text-align: center;
  position: fixed;
}

@media only screen and (min-device-aspect-ratio:3/2) and (max-width: 1024px) and (orientation: landscape) {
  html {
    #app {
      display: none;
    }
    .shrug {
      opacity: 1;
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: $color-wrapper-emphasis-lighter;
      z-index: 10000;
      color: white;
      font-size: 20px;
      .super-big {
        font-size: 50px;
        display: block;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
